<div class="layout-col full">
  <span style="width: 90vw"></span>

  <app-package-type-detail class="flex" [packageType]="packageType" (close)="onClose($event)">
  </app-package-type-detail>
</div>
